import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
//Material UI Imports
import {
  MenuItem,
} from '@mui/material';

const Localcustomer = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(291)); 
console.log(permission);

    axios.post("/decay-customers/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.customers);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


const editItem = (item)=>{
  window.location.href = "/local-customers-edit/"+item;
}


  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/local-customers/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/local-customers";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const columns =
 [
   
    {
      accessorKey: 'name', //normal accessorKey
      header: 'Name',
    },
    {
      accessorKey: 'phone_number', //normal accessorKey
      header: 'Phone Number',
    },
    {
      accessorKey: 'address',
      header: 'Address',
    },
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Local Customers</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Local Customers</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission && permission.add == 1 && (
                  <Link to="/local-customers-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link>
                )} 
                
              </div>
            </div>
          </div>

          <div className="row">
         
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                  {permission && permission.list == 1 && (
                    <MaterialReactTable columns={columns} data={data} 
                    // enableColumnFilterModes
                    enableColumnOrdering
                    // enableGrouping
                    enablePinning
                    enableRowActions
                    // enableRowSelection
                    // initialState={{ showColumnFilters: true }}
                   
                    renderRowActionMenuItems={({ row }) => [
                      permission?.update == 1 && (
                        <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                          Edit
                        </MenuItem>
                      ),
                      permission?.delete == 1 && (
                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                          Delete
                        </MenuItem>
                      ),
                    ]}
                  />
                  )} 
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Localcustomer;
